import { useState, useEffect } from 'react'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || ''

export interface AdminNotificationCounts {
  pendingPayments: number
  pendingWithdrawals: number
  openSupportTickets: number
  pendingConsultations: number
  pendingKyc: number
  pendingCertificates: number
  pendingTasks: number
  pendingTopups: number
  totalPending: number
}

export const useAdminNotifications = () => {
  const [counts, setCounts] = useState<AdminNotificationCounts>({
    pendingPayments: 0,
    pendingWithdrawals: 0,
    openSupportTickets: 0,
    pendingConsultations: 0,
    pendingKyc: 0,
    pendingCertificates: 0,
    pendingTasks: 0,
    pendingTopups: 0,
    totalPending: 0
  })
  const [loading, setLoading] = useState(true)

  const fetchNotificationCounts = async () => {
    try {
      const sessionId = localStorage.getItem('aureus_server_session_id')
      if (!sessionId) {
        setLoading(false)
        return
      }

      const response = await fetch(`${API_BASE_URL}/api/admin/notification-counts`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Session-Id': sessionId
        }
      })

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`)
      }

      const result = await response.json()
      console.log('🔔 Admin notification counts response:', result)
      if (result.success && result.counts) {
        console.log('🔔 Setting notification counts - openSupportTickets:', result.counts.openSupportTickets)
        setCounts(result.counts)
      }
    } catch (error) {
      console.error('Error fetching admin notification counts:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchNotificationCounts()

    // Refresh counts every 30 seconds
    const interval = setInterval(fetchNotificationCounts, 30000)

    return () => clearInterval(interval)
  }, [])

  return {
    counts,
    loading,
    refresh: fetchNotificationCounts
  }
}

// Helper function to get badge count for specific tab
export const getBadgeCountForTab = (tabId: string, counts: AdminNotificationCounts): number => {
  switch (tabId) {
    case 'todo':
      return counts.pendingTasks
    case 'payments':
      return counts.pendingPayments
    case 'payment-management':
      return counts.pendingPayments
    case 'commissions':
      return counts.pendingWithdrawals
    case 'withdrawal-management':
      return counts.pendingWithdrawals
    case 'support':
      return counts.openSupportTickets
    case 'meetings':
      return counts.pendingConsultations
    case 'users':
      return counts.pendingKyc
    case 'kyc':
      return counts.pendingKyc
    case 'certificates':
      return counts.pendingCertificates
    case 'topup-approval':
      return counts.pendingTopups
    default:
      return 0
  }
}
